import React__default, { useRef, useCallback } from 'react';
import { VisibilityObserver } from './context.js';
export { useVisibilityObservable } from './context.js';
import { SlotContainer } from './slot-container.js';

var InfiniteScroll = function InfiniteScroll(_ref) {
  var Placeholder = _ref.Placeholder,
    children = _ref.children,
    numItems = _ref.numItems,
    perPage = _ref.perPage,
    setPages = _ref.setPages;
  var visible = useRef([]);
  var recalculate = useCallback(function () {
    var visiblePages = {};
    for (var i = 0; i < visible.current.length; i++) {
      if (visible.current[i]) {
        visiblePages[i / perPage | 0] = true;
      }
    }
    setPages(Object.keys(visiblePages).map(Number));
  }, [perPage, setPages, visible]);
  var onObservable = useCallback(function (entries) {
    entries.forEach(function (e) {
      if (e.target.dataset.idx) {
        visible.current[parseInt(e.target.dataset.idx, 10)] = e.isIntersecting;
      }
    });
    requestIdleCallback(recalculate);
  }, [visible, recalculate]);
  return /*#__PURE__*/React__default.createElement(VisibilityObserver, {
    onObservable: onObservable
  }, /*#__PURE__*/React__default.createElement(SlotContainer, {
    numItems: numItems,
    SlotPlaceholder: Placeholder
  }, children));
};

export { InfiniteScroll };
//# sourceMappingURL=index.js.map
